function addItemToBag(variantId) {
    var cartItems = {
        quantity: 1,
        id: variantId,
        properties: {
            '_is_bundle': false,
            '_Type': 'OneTimePurchase',
            '_attribution': 'One Time Purchase'
        }
    };
    // Updated add to cart with correct success
    $.ajax({
        url: '/cart/add.json',
        type: 'post',
        dataType: 'json',
        data: cartItems,
        success: function(response) {
            console.log('');
            console.log('%c' + response.title + "%c was added to cart.", 'color: green','color: black',);

            if(showVueCart == true) {
                window.miniCart.refreshCart();
            }
        },
        error: function(response) {
            var errors = JSON.parse(response.responseText);
            console.log(errors.errors);
        }
    });

    $(".collection-vue__container__products__product").removeClass("is-active");

    $('#about-scent .addToCart').addClass("added");
    $('#about-scent .addToCart').html("Added!");

    setTimeout(function() {
        $('#about-scent .addToCart').html("add to bag");
        $('#about-scent .addToCart').removeClass("added");
    }, 2500);
}